import { GroceryModel } from './model.js';
import { GroceryView } from './view.js';
import { GroceryController } from './controller.js';

new GroceryController(new GroceryModel(), new GroceryView());
